/*eslint-disable */
var $ = window.jQuery = require('jquery');

import commonSocket from '@/commonSocket/index.js';
import {
  mapGetters,
} from 'vuex';

export default {
  name: 'jisti-video-confreness',
  components: {},
  props: [],
  data() {
    return {
      selfUserProfileDetails:null,
      apiObj:null,
      domain:process.env.VUE_APP_VIDEO_DOMAIN,
      callerRoomId:'',
      selfUserFullName:'',
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
    ]),
    getUserDetailsInfo() {
      this.selfUserProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    setIntialUserIdFun(){
      if(this.selfUserProfileDetails){
        this.selfUserFullName = this.selfUserProfileDetails.first_name + ' ' + this.selfUserProfileDetails.last_name
      }
    }
  },
  mounted() {
    if (!location.hash) {
      location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    }
    this.callerRoomId = location.hash.substring(1);
    this.getUserDetailsInfo
    this.StartMeetingMethod(this.callerRoomId, this.selfUserFullName)
  },
  methods: {
    StartMeetingMethod(roomName, dispNme) {
      const options = {
        roomName: roomName,
        width: '100%',
        height: '100%',
        parentNode: document.querySelector('#jitsi-meet-conf-container'),
        userInfo: {
          email:  this.selfUserProfileDetails.email,
          displayName: dispNme
        },
      }
      this.apiObj = new JitsiMeetExternalAPI(this.domain, options);
      this.apiObj.on('readyToClose', () => {
        window.location.href = '/video/one-to-one-peer/left/room/#' + location.hash.substring(1);
      })
    },
  },
  beforeCreate: function () {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    $('body').addClass('video_conference_page')
    $('body').addClass('zisti_video_main_wrp')
  },  
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('video_conference_page')
    $('body').removeClass('zisti_video_main_wrp')
    next();
  },
  watch: {
    getUserDetailsInfo() {
      return this.$store.getters.acUserDetailsStateGetters
    },
    setIntialUserIdFun(){
      if(this.selfUserProfileDetails){
        this.selfUserFullName = this.selfUserProfileDetails.first_name + ' ' + this.selfUserProfileDetails.last_name
      }
    }
  },
}